export function SaveRoleHistory(this: any, roleId: number) {
    const { comment, name } = this;
    return {
        roleId,
        name,
        comment
    }
}
